import { AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';

export function TimesheetWarnings({ warnings = [], detail = false }) {
  if (!warnings.length) return null;
  return <div className="space-y-1 text-red-800 dark:text-red-200" aria-label="Timesheet review warnings">
    {warnings.map(warning => <div key={warning.code}>
      <span className="inline-flex items-center gap-1 rounded bg-red-100 dark:bg-red-950 px-2 py-1 text-[10px] font-bold">
        <AlertTriangle aria-hidden="true" className="h-3.5 w-3.5 shrink-0" />{warning.label}
      </span>
      {detail && <div className="text-xs mt-1"><p>{warning.reason}</p>
        {!!warning.related_ids?.length && <p>Related timesheets: {warning.related_ids.map((id, i) => <span key={id}>{i > 0 && ', '}<Link className="underline font-medium" to={`/app/timesheets?record=${encodeURIComponent(id)}`}>{id}</Link></span>)}{warning.related_ids.length === 20 && ' (showing up to 20 related records)'}</p>}
      </div>}
    </div>)}
  </div>;
}
